import { Container } from '@radix-ui/themes'
import { useLoaderData, useOutletContext } from '@remix-run/react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'

import { Header } from '#app/routes/($lang)._index/header'
import { InfoGrid } from '#app/routes/($lang)._index/info-grid'
import { Partners } from '#app/routes/($lang)._index/partners'
import { ProductsSlider } from '#app/routes/($lang)._index/products-slider'
import { INDEX_I18NEXT } from '#app/routes/($lang)._index/route-config'
import { type loader } from '#app/routes/($lang)._index/server.route'
import { type Context } from '#app/routes/_layout/route-config.ts'
import { Alert } from '#app/routes/($lang)._index/alert.tsx'

/* -------------------------------------------------------------------------------------------------
 * Component
 * -----------------------------------------------------------------------------------------------*/

const Component: React.FC = () => {
	const { products } = useLoaderData<typeof loader>()
	const { t } = useTranslation(INDEX_I18NEXT.routeIndex)
	const { locale } = useOutletContext<Context>()

	return (
		<>
			<Container px="5" my="9">
				<Header />
			</Container>
      {/*
        <Container px="5" my="9">
          <Alert />
        </Container>
      */}
			<Container px="5" my="9">
				<ProductsSlider products={products} />
				<InfoGrid products={products} locale={locale} t={t} />
			</Container>
			<Partners t={t} />
		</>
	)
}
Component.displayName = 'Component'

/* -----------------------------------------------------------------------------------------------*/

export { Component }
